import { HttpInterceptorFn } from '@angular/common/http';

export const addDateInterceptor: HttpInterceptorFn = (req, next) => {
  const testDomainPattern =
    /api\.aws\.(test\.test\.domgenusa-test\.cloud|preprod\.domgen-usa\.com|domgen-usa\.com)|api\.global-reg\.e2e-domgendotcom-(qa|dev|prod)\.aws\.domgencloud\.net/;
  if (testDomainPattern.test(req.url)) {
    const cloned = req.clone({
      setHeaders: {
        'content-type':
          req.headers.get('content-type') ||
          req.headers.get('Content-Type') ||
          'application/json', // Allow content type header set on request to persist otherwise override
        'x-date-override': new Date().toISOString(),
      },
    });
    return next(cloned);
  }
  return next(req);
};
